import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { AppProviders } from "./app/app-providers";
import {
	installPreloadErrorReload,
	startVersionCheck,
} from "./lib/version-check";

import "./locales/i18n-provider";

// Must run before render so route-chunk failures during the initial route
// load are already caught.
installPreloadErrorReload();
startVersionCheck();

const container = document.getElementById("app");
if (!container) {
	throw new Error("Missing #app root element");
}

createRoot(container).render(
	<StrictMode>
		<AppProviders>
			<App />
		</AppProviders>
	</StrictMode>
);
